.content {
  overflow: scroll;
}

.navIcon path {
  fill: var(--icon-button-normal-state-icon-color);
}
